module.exports = "/next-static/_next/static/images/multistream-63ad5dbb1235c1127b84056ff7a0a7b6.png";